<template>
<v-container fill-height fluid class="session-container">
    <v-row align-content="center" justify="center" class="ma-0">
        <v-col cols="12" sm="6" md="5" lg="4" align="center" justify="center" align-self="stretch">
            <v-img src="@/assets/logo.svg" alt="logo" transition="scale-transition" class="mx-1 mb-5 shrink" width="250px" />
            <router-view />
        </v-col>
    </v-row>
</v-container>
</template>

<script>
export default {
    mounted() {
        /*this.$store.dispatch("setPerson", {
            show: true,
            msg: 'hola mundo',
            color: 'error'
        });*/
    }
}
</script>
